import { ReactComponent } from "./profile-manager.svg";

interface Props {
  fill?: string;
  width?: number;
  height?: number;
}

const ProfileManagerIcon: React.FC<Props> = ({ fill, width, height }) => (
  <ReactComponent fill={fill} width={width} height={height} />
);

export default ProfileManagerIcon;
